/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the OrderCategoryDto interface.
 */
export function instanceOfOrderCategoryDto(value) {
    return true;
}
export function OrderCategoryDtoFromJSON(json) {
    return OrderCategoryDtoFromJSONTyped(json, false);
}
export function OrderCategoryDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'value': json['value'] == null ? undefined : json['value'],
        'isTypePassivo': json['isTypePassivo'] == null ? undefined : json['isTypePassivo'],
    };
}
export function OrderCategoryDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'value': value['value'],
        'isTypePassivo': value['isTypePassivo'],
    };
}
